const isSidebarItemVisible = (
  visibility: "all" | "loggedIn" | "loggedOut" | undefined,
  active: boolean | undefined,
  isLoggedIn: boolean,
  featureFlag: string | undefined,
  enabledFeatureFlags: Set<string>,
): boolean => {
  if (active === false) return false;
  if (featureFlag && !enabledFeatureFlags.has(featureFlag)) return false;

  switch (visibility) {
    case "loggedIn":
      return isLoggedIn;
    case "loggedOut":
      return !isLoggedIn;
    default:
      return true;
  }
};

export default isSidebarItemVisible;
